<div class="item-title">
  <ng-content />
</div>
<si-icon class="d-block dropdown-caret" [icon]="icons.elementDown2" />
